import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandAnimation = trigger('slideInOut', [
	state(
		'in',
		style({
			overflow: 'hidden',
		}),
	),
	state(
		'out',
		style({
			opacity: '0',
			overflow: 'hidden',
			height: '0',
			margin: '0',
			padding: '0',
		}),
	),
	transition('in => out', animate('200ms ease-in-out')),
	transition('out => in', animate('200ms ease-in-out')),
]);

export const rotateAnimation = trigger('rotateInOut', [
	state(
		'in',
		style({
			transform: 'rotate(0deg)',
		}),
	),
	state(
		'out',
		style({
			transform: 'rotate(-90deg)',
		}),
	),
	transition('in => out', animate('200ms ease-in-out')),
	transition('out => in', animate('200ms ease-in-out')),
]);

export const fadeAnimation = trigger('fadeInOut', [
	state('inactive', style({ opacity: 1, transform: 'translateX(0) scale(1)' })),
	state('active', style({ opacity: 1, transform: 'translateX(0) scale(1)' })),
	state('void', style({ opacity: 0, display: 'none', transform: 'translateX(0) scale(1)' })),
	transition('* => void', [
		animate(
			'200ms ease-in-out',
			style({
				height: '0',
				padding: '0 20px',
				overflow: 'hidden',
			}),
		),
	]),
]);
